import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFontFile = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2147 22.324H19.238L20.7856 26.193H22.4525L17.5002 13.8122H15.9526L11.0003 26.193H12.6671L14.2147 22.324ZM16.7264 16.0447L18.619 20.7764H14.8337L16.7264 16.0447Z",
			fill: "#88819F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26.7857 20.0026V20.4166C26.3305 20.1533 25.8019 20.0026 25.2381 20.0026C23.5287 20.0026 22.143 21.3884 22.143 23.0978C22.143 24.8072 23.5287 26.193 25.2381 26.193C25.8019 26.193 26.3305 26.0422 26.7857 25.7789V26.193H28.3333V20.0026H26.7857ZM26.7857 23.0978C26.7857 23.9525 26.0929 24.6454 25.2381 24.6454C24.3834 24.6454 23.6905 23.9525 23.6905 23.0978C23.6905 22.243 24.3834 21.5502 25.2381 21.5502C26.0929 21.5502 26.7857 22.243 26.7857 23.0978Z",
			fill: "#88819F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35 34.9913V13.3359L24.9946 3.33594H6.67032C5.7478 3.33594 4.99997 4.09479 4.99997 4.98894V35.0163C4.99997 35.9293 5.74155 36.6693 6.65564 36.6693H33.3443C34.2586 36.6693 35 35.9194 35 34.9913ZM23.3333 15.0026H31.6666V33.3359H8.3333V6.66927H23.3333V15.0026Z",
			fill: "#88819F"
		})
	]
});
const ForwardRef = forwardRef(SvgFontFile);
export default ForwardRef;
